import React, { useContext } from "react"
import Header from "./Common/Header"
import Breadcrumb from "./Common/Breadcrumb"
import Footer from "./Common/Footer"
import Container from "./List/Container"
import { PCViewContext } from "./Common/PCViewContext"

const List = (props) => {
  const isPC = useContext(PCViewContext)

  return (
    <React.Fragment>
      {isPC && (
        <React.Fragment>
          <Header />
          <Breadcrumb {...props} />
          <Container {...props} />
          <Footer {...props} />
        </React.Fragment>
      )}
      {!isPC && (
        <React.Fragment>
          <Header />
          <Container {...props} />
          <Breadcrumb {...props} />
          <Footer {...props} />
        </React.Fragment>
      )}
    </React.Fragment>
  )
}
export default List
